var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74141 11.4861C7.94955 11.5969 8.21386 11.5646 8.38926 11.3892L13.8388 5.93974C14.0537 5.72476 14.0537 5.37621 13.8388 5.16123C13.6238 4.94626 13.2752 4.94626 13.0603 5.16123L8.00001 10.2215L2.93974 5.16122C2.72476 4.94625 2.37622 4.94625 2.16124 5.16122C1.94626 5.3762 1.94626 5.72475 2.16124 5.93973L7.61075 11.3892C7.61075 11.3892 7.61075 11.3892 7.61076 11.3892C7.65034 11.4288 7.69445 11.4611 7.74141 11.4861Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expandMore.d18ab5c959de41c3d97b8135df9d4e1f.svg";
export { ForwardRef as ReactComponent };